import { Formik, Form } from "formik";
import * as Yup from "yup";
import React from "react";
import { FaCheckDouble } from "react-icons/fa";
import CustomButton from "../../../shared/CustomButton";
import { useTranslation } from "react-i18next";
import DropdownField from "../../../shared/DropdownField";
import CheckPermission from "../../../hooks/CheckPermission";

export const cancelReasonDropdown = [
  {
    label: "Patient: Canceled via automated reminder system",
    value: "pat-crs",
  },
  { label: "Patient: Canceled via Patient Portal", value: "pat-cpp" },
  { label: "Patient: Deceased", value: "pat-dec" },
  { label: "Patient: Feeling Better", value: "pat-fb" },
  { label: "Patient: Lack of Transportation", value: "pat-lt" },
  {
    label: "Patient: No longer covered by insurance or other payers",
    value: "pat-mt",
  },
  { label: "Patient: Moved Residence", value: "pat-mv" },
  { label: "Patient: Pregnant", value: "pat-preg" },
  { label: "Patient: Scheduled from Wait List", value: "pat-swl" },
  { label: "Patient: Unhappy/Changed Provider", value: "pat-ucp" },
  { label: "Provider: Personal", value: "prov-pers" },
  { label: "Provider: Discharged", value: "prov-dch" },
  { label: "Provider: Edu/Meeting", value: "prov-edu" },
  { label: "Provider: Hospitalized", value: "prov-hosp" },
  { label: "Provider: Labs Out of Acceptable Range", value: "prov-labs" },
  {
    label: "Provider: MRI Screening Form Marked Do Not Proceed",
    value: "prov-mri",
  },
  { label: "Provider: Oncology Treatment Plan Changes", value: "prov-onc" },

  { label: "Equipment Maintenance/Repair", value: "maint" },
  { label: "Prep/Med Incomplete", value: "meds-inc" },

  { label: "Other: CMS Therapy Cap Service Not Authorized", value: "oth-cms" },
  { label: "Other: Error", value: "oth-err" },
  { label: "Other: Financial", value: "oth-fin" },
  { label: "Other: Improper IV Access/Infiltrate IV", value: "oth-iv" },
  { label: "Other: No Interpreter Available", value: "oth-int" },
  { label: "Other: Prep/Med/Results Unavailable", value: "oth-mu" },
  { label: "Other: Room/Resource Maintenance", value: "oth-room" },
  { label: "Other: Schedule Order Error", value: "oth-oerr" },
  { label: "Other: Silent Walk In Error", value: "oth-swie" },
  { label: "Other: Weather", value: "oth-weath" },
  { label: "Other", value: "other" },
];

const CancelAppointmentForm = ({ handleCancel, cancelLoading }) => {
  const { hasPermission } = CheckPermission();
  const canCancel = hasPermission('appointments', 'update');
  const initialValues = {
    reason: "other",
    inputReason: "",
  };
  const { t } = useTranslation();

  const validationSchema = Yup.object().shape({
    reason: Yup.string().trim().required(t("Reason is required")),
  });
  return (
    <div>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          if (!canCancel) return;
          const hl7Reason = cancelReasonDropdown.find(
            (item) => item?.value == values?.reason
          );
          const payload = {
            coding: [
              {
                system:
                  "http://terminology.hl7.org/CodeSystem/appointment-cancellation-reason",
                code:
                  values?.reason === "other"
                    ? values?.inputReason
                    : hl7Reason?.value,
                display:
                  values?.reason === "other"
                    ? values?.inputReason
                    : hl7Reason?.label,
              },
            ],
            text:
              values?.reason === "other"
                ? values?.inputReason
                : hl7Reason?.label,
          };
          handleCancel(payload);
        }}
      >
        {({ errors, touched, handleChange, handleBlur, values }) => (
          <Form>
            <DropdownField
              label={t("Cancel Reason")}
              options={cancelReasonDropdown.map((opt) => ({
                ...opt,
                label: t(opt.label),
              }))}
              filter
              name="reason"
              className="w-full mb-2"
            />
            {values?.reason === "other" && (
              <div className={`flex flex-col gap-1 w-full mb-3 `}>
                <label className="input-label">{t("Add Reason")}</label>
                <textarea
                  placeholder={t("Enter reason")}
                  className="w-full p-2 bg-gray-100 rounded-lg border border-gray-300 hover:border-primary !outline-none !shadow-none text-[14px]"
                  name="inputReason"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  rows={3}
                />
                {errors.reason && touched.reason && (
                  <span className="text-sm text-red-500">{errors.reason}</span>
                )}
              </div>
            )}

            {canCancel && (
              <div className="flex items-center justify-end">
                <CustomButton
                  loading={cancelLoading}
                  type="submit"
                  icon={<FaCheckDouble size={12} className="me-2" />}
                  label={t("Cancel Appointment")}
                  buttonType="primary"
                />
              </div>
            )}
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default CancelAppointmentForm;
